import { render } from "./LayoutShoppingCart.vue?vue&type=template&id=37cdf064"
import script from "./LayoutShoppingCart.vue?vue&type=script&lang=js"
export * from "./LayoutShoppingCart.vue?vue&type=script&lang=js"

import "./LayoutShoppingCart.vue?vue&type=style&index=0&id=37cdf064&lang=css"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__